import {
  Badge,
  DataTable,
  FlexBox,
  HelpIcon,
  IconButton,
  Switch,
  Text,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { useNavigate } from 'react-router-dom';

import { ChatCSAT } from '../ChatCSAT/types';

type OwnProps = {
  languages: ChatCSAT.Language[];
  onLanguageStatusChange: (
    change: ChatCSAT.LanguageCustomizationStatusChange,
  ) => void;
};

export interface LanguagesStateProps {
  defaultLanguageCode: string | null;
}

type Props = OwnProps & LanguagesStateProps;

export const Languages = ({
  defaultLanguageCode,
  languages,
  onLanguageStatusChange,
}: Props): JSX.Element => {
  const navigate = useNavigate();

  return (
    <DataTable
      data={languages}
      columns={[
        {
          label: 'Language',
          selector: (language) => {
            const isDefault = language.code === defaultLanguageCode;

            if (isDefault) {
              return (
                <FlexBox gap="250" alignItems="center">
                  <Text.Paragraph as="span">{language.name}</Text.Paragraph>

                  <Badge variant="primary" size="small">
                    Default
                  </Badge>

                  <HelpIcon text="CSAT ratings have English enabled by default and you can edit the English text, but it cannot be disabled." />
                </FlexBox>
              );
            }

            return (
              <Text.Paragraph color={language.isSetup ? 'primary' : 'tertiary'}>
                {language.name}
              </Text.Paragraph>
            );
          },
        },
        {
          label: 'Enabled',
          selector: (language) => {
            const isDefault = language.code === defaultLanguageCode;

            if (language.isSetup && !isDefault) {
              return (
                <Switch
                  name={language.code}
                  value={language.code}
                  checked={language.enabled}
                  onChange={() =>
                    onLanguageStatusChange({
                      language,
                      newStatus: !language.enabled,
                    })
                  }
                />
              );
            }
          },
          style: {
            width: 0,
          },
        },
        {
          label: '',
          selector: (language) => {
            return (
              <Tooltip content={language.isSetup ? 'Edit' : 'Setup'}>
                <IconButton
                  icon={language.isSetup ? 'pen' : 'cog'}
                  variant="tertiary"
                  onClick={() =>
                    navigate(`/settings/satisfaction/chat/${language.code}`)
                  }
                />
              </Tooltip>
            );
          },
          style: {
            width: 0,
          },
        },
      ]}
      tableStyleProps={{
        stickyHeader: true,
      }}
    />
  );
};
